// @ts-nocheck
import axios, { AxiosError, AxiosInstance } from "axios";
import { ERROR__MESSAGES } from "../constants/errors";

export function httpServiceFactory({
  baseUrl,
  getAuthorizationFn,
  getUrlParamsFn,
}: {
  baseUrl: string;
  getAuthorizationFn: () => string;
  getUrlParamsFn: () => Record<string, string>;
}): AxiosInstance {
  const axiosInstance = axios.create({
    baseURL: baseUrl,
  });
  axiosInstance.interceptors.request.use(
    (config) => {
      if (getAuthorizationFn && config.headers.Authorization == null) {
        config.headers = {
          Authorization: getAuthorizationFn(),
          ...config.headers,
        };
      }
      if (getUrlParamsFn) {
        const params = getUrlParamsFn();

        config.url = Object.entries(params).reduce(
          (url, [key, value]) => url.replace(`{{${key}}}`, value),
          config.url
        );
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
  return axiosInstance;
}

export const generateQuery = (
  params: string[][] | Record<string, string> | string | URLSearchParams
): string => new URLSearchParams(params).toString();

export function generateUrl({ url, query }: { url: string; query: Record<string, string> }) {
  if (!query || Object.values(query).filter(Boolean).length === 0) {
    return url;
  }
  return `${url}?${generateQuery(query)}`;
}

export function getErrorMessage(
  error: AxiosError<{ error: string; status: number }>,
  fallbackMessage: string = ""
) {
  let parsedError: any = error?.response?.data;
  if (parsedError?.error in ERROR__MESSAGES) {
    return ERROR__MESSAGES[parsedError?.error];
  }
  return fallbackMessage;
}
